import { render, staticRenderFns } from "./SideMenuExpandLink.vue?vue&type=template&id=9188a9e6&scoped=true"
import script from "./SideMenuExpandLink.vue?vue&type=script&lang=ts"
export * from "./SideMenuExpandLink.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuExpandLink.vue?vue&type=style&index=0&id=9188a9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9188a9e6",
  null
  
)

export default component.exports